/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars
import React from "react";
import Die from "./components/Die";
import {nanoid} from "nanoid"
import Confetti from "react-confetti"

export default  function App(){

 
 const [dice, setDice] = React.useState(allNewDice())  
 const [tenzies, setTenzies]= React.useState(false)

function allNewDice (){
    const newDice = []

   for(let i=0; i<10; i++){
    newDice.push({ value:Math.floor(Math.random()*6) + 1,
         isHeld:false,
        id:nanoid()})
   } return newDice
}
//console.log(allNewDice)
const diceElements =dice.map(die => <Die  key={die.id} value={die.value}  isHeld={die.isHeld} holdDice={() => holdDice(die.id)}/>)

function rollDice (){
    if(!tenzies){setDice(oldDice => oldDice.map(die => {
        return die.isHeld ? die :
        {
            value: Math.ceil(Math.random() * 6),
            isHeld: false,
            id: nanoid()
        }
 }))}else {
    setTenzies(false)
            setDice(allNewDice())
 }
     

}
function holdDice (id){
    setDice(oldDice => oldDice.map(die => {
        return die.id === id ? 
            {...die, isHeld: !die.isHeld} :
            die
    }))
 }


 React.useEffect(() =>{
    const allHeld = dice.every(die => die.isHeld)
    const firstValue = dice[0].value
    const allSameValue = dice.every(die => die.value === firstValue)
    if (allHeld && allSameValue) {
        setTenzies(true)
        console.log("You won!")
    }

 }, [dice])




    return (
        <main>
            {tenzies && <Confetti/>}
            <h1 className="title">Tenzies</h1>

            <p className="instructions">{ tenzies ?"Hurray!":"Roll until all dice are the same. Click each die to freeze it at its current value between rolls"}.</p>
            <div className="dice--container">
            {diceElements}
            </div>
            <div>
                <button className="roll-btn" onClick={rollDice}>{tenzies ? "New Game" : "Roll"}</button>
            </div>
        </main>
    )
}